import { API } from "../constant";
import { fetchWithAuth } from "./fetchWithAuth";

// Strapi v4 возвращает {id, attributes:{...}} — разворачиваем в плоский объект,
// как это уже делается в fetchMenu (App.jsx: item.attributes.isDiagram).
const normalizeEntity = (item) =>
	item ? { id: item.id, ...item.attributes } : null;

const normalizeList = (json) => (json?.data ?? []).map(normalizeEntity);

const normalizeUnitRelation = (unitRelation) => {
	const unit = unitRelation?.data;
	return unit ? { id: unit.id, ...unit.attributes } : null;
};

export async function getPages() {
	const res = await fetchWithAuth(`${API}/pages?sort=updatedAt:desc`);
	const json = await res.json();
	return normalizeList(json);
}

export async function getPage(id) {
	const res = await fetchWithAuth(
		`${API}/pages/${id}?populate[widgets][populate]=unit`,
	);
	if (!res.ok) throw new Error("Не удалось загрузить страницу");
	const json = await res.json();

	const page = normalizeEntity(json.data);
	if (!page) return null;

	const widgetsRelation = json.data.attributes.widgets?.data ?? [];
	page.widgets = widgetsRelation.map((w) => ({
		id: w.id,
		...w.attributes,
		unit: normalizeUnitRelation(w.attributes.unit),
	}));

	return page;
}

export async function createPage({ name, slug, description }) {
	const res = await fetchWithAuth(`${API}/pages`, {
		method: "POST",
		body: JSON.stringify({ data: { name, slug, description } }),
	});
	if (!res.ok) throw new Error("Не удалось создать страницу");
	const json = await res.json();
	return normalizeEntity(json.data);
}

export async function deletePage(id) {
	const res = await fetchWithAuth(`${API}/pages/${id}`, {
		method: "DELETE",
	});
	if (!res.ok) throw new Error("Не удалось удалить страницу");
}

export async function createPageWidget({ pageId, unitId, x, y, w, h }) {
	const res = await fetchWithAuth(`${API}/page-widgets`, {
		method: "POST",
		body: JSON.stringify({
			data: {
				page: pageId,
				unit: unitId,
				widgetType: "UNIT",
				x,
				y,
				w,
				h,
			},
		}),
	});
	if (!res.ok) {
		const err = await res.json().catch(() => null);
		throw new Error(err?.error?.message ?? "Не удалось добавить виджет");
	}
	const json = await res.json();
	return normalizeEntity(json.data);
}

export async function deletePageWidget(id) {
	const res = await fetchWithAuth(`${API}/page-widgets/${id}`, {
		method: "DELETE",
	});
	if (!res.ok) throw new Error("Не удалось удалить виджет");
}

// Один запрос на все сдвинутые/зарезайженные виджеты разом —
// вызывается по onDragStop/onResizeStop, а не на каждый пиксель перетаскивания.
export async function batchUpdateLayout(items) {
	const res = await fetchWithAuth(`${API}/page-widgets/batch-layout`, {
		method: "PUT",
		body: JSON.stringify({ items }),
	});
	if (!res.ok) {
		const err = await res.json().catch(() => null);
		throw new Error(err?.error?.message ?? "Не удалось сохранить layout");
	}
	return res.json();
}
